import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconIbd(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-.09 11.06 2 14v19.57l-2.1 2.94h8.24L6 33.57V14l2.12-3ZM18.44 36.48H9.85l2-2.78V13.78l-2-2.78h8.77c5.16 0 7.48 3 7.48 6.26s-1.62 5.2-3.63 5.78a6.3 6.3 0 0 1 4.64 6.11c0 4.58-2.81 7.33-8.67 7.33Zm0-22.51h-2.76v7.91H18c2.62 0 4.21-1.71 4.21-4.37A3.43 3.43 0 0 0 18.46 14Zm.6 11h-3.36v8.43h3c2.86 0 4.42-1.73 4.42-4.11A4 4 0 0 0 19.06 25ZM35.67 10.89h-8.25l1.92 2.84v19.76l-1.92 2.87h8.65c6.87 0 10.5-4.61 10.5-13.26 0-7.51-3.48-12.21-10.9-12.21Zm.06 22.33h-2.31V13.91h2c4.79 0 7 3.39 7 9.55-.07 6.86-2.51 9.76-6.69 9.76ZM47 12.19c0-.31-.24-.49-.59-.49h-.51v1.69h.29v-.7h.16l.5.72.3-.07-.49-.68a.47.47 0 0 0 .34-.47Zm-.59.27h-.22v-.53h.24c.2 0 .31.09.31.26s-.17.27-.37.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.39 11a1.48 1.48 0 0 0-1.52 1.57 1.52 1.52 0 1 0 3 0A1.47 1.47 0 0 0 46.39 11Zm0 3a1.28 1.28 0 0 1-1.31-1.38 1.31 1.31 0 1 1 2.62 0A1.27 1.27 0 0 1 46.39 14Z"
  }));
}
IconIbd.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconIbd.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconIbd as default };
